import photo1 from './project20-1.png';
import photo2 from './project20-2.png';
import photo3 from './project20-3.png';
import photo4 from './project20-4.png';

const project20 = {
  id: 20,
  name: 'KARMA',
  team: [
    {
      position: 'FrontEnd Developer',
      names: '박서연 이가빈',
    },
    {
      position: 'BackEnd Developer',
      names: '문서영 유효주 정지은',
    },
    {
      position: 'UXUI Designer',
      names: '박서연 이가빈',
    },
  ],
  about:
    "'패스트 패션'의 트렌드가 전 세계적으로 확산되면서, 해마다 기하급수적으로 증가하는 의류 폐기물이 커다란 환경 문제로 자리 잡고 있습니다. 카르마는 이러한 문제에 주목하여 옷을 단순히 폐기하거나 재활용하는 것에서 벗어나 새로운 가치로 재탄생시키는 작업에 대한 관심에서 출발한 개인 맞춤형 의류 업사이클링 의뢰 플랫폼입니다.",
  links: {
    website: 'https://ecyce.netlify.app/',
    github: 'https://github.com/efub-ecyce',
  },
  photos: [photo1, photo2, photo3, photo4],
};

export default project20;
